import React from 'react';
import { Svg, Circle, G, Path } from 'react-native-svg';

const BusDeparture = () => (
  <Svg width="24" height="24">
    <G
      fill="none"
      fillRule="evenodd"
      stroke="#696969"
      strokeLinecap="round"
      strokeWidth="2"
    >
      <Path d="M2.737 6h17.274c1.178 0 2.205.799 2.495 1.94l.401 1.576a3 3 0 0 1 .093.74V17a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V7.737A1.737 1.737 0 0 1 2.737 6z" />
      <Path d="M23 15a2.42 2.42 0 0 1-1.218-.324l-1.775-1.037c-.628-.367-1.007-.992-1.007-1.662V9.993c0-.548.498-.993 1.112-.993h2.225" />
      <Circle cx="5" cy="18" r="2" fill="#FFF" />
      <Circle cx="18" cy="18" r="2" fill="#FFF" />
      <Path d="M9 12H4m3-3h8a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-3" />
    </G>
  </Svg>
);

export default BusDeparture;
